import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';

const CartSync = () => {
  const { user } = useAuth();
  const { syncCartOnLogin, loadCart } = useCart();
  const hasSynced = useRef(false);
  const isLoading = useRef(false);

  useEffect(() => {
    const syncCart = async () => {
      if (isLoading.current) return; // Prevent concurrent syncs
      
      if (user && !hasSynced.current) {
        // User logged in, sync cart (only once)
        isLoading.current = true;
        hasSynced.current = true;
        try {
          await syncCartOnLogin();
        } finally {
          isLoading.current = false;
        }
      } else if (!user && hasSynced.current) {
        // User logged out, reset sync flag and load local cart
        hasSynced.current = false;
        isLoading.current = true;
        try {
          await loadCart();
        } finally {
          isLoading.current = false;
        }
      }
    };

    syncCart();
  }, [user, syncCartOnLogin, loadCart]);

  return null; // This component doesn't render anything
};

export default CartSync;
